// extracted by mini-css-extract-plugin
export default {"facilityName":"_2dacEhT4NdnO534ZlZjvxd","facilityAddress":"_2Zltg8QUhiHo8MqXb2C3-C","customGrid":"_2mwWmOr3-Jp3SETBE7KtJg"};